(() => {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');
  const root = document.documentElement.dataset.root || '/';
  const strings = JSON.parse(document.getElementById('BayStrings')?.textContent || '{}');
  const initialized = new WeakSet();
  let variantController;
  let toastTimer;

  function updateHeader() {
    document.querySelectorAll('[data-header]').forEach(header => header.classList.toggle('is-scrolled', window.scrollY > 25));
  }

  function init(scope = document) {
    updateHeader();
    scope.querySelectorAll('[data-filter-dialog]').forEach(dialog => {
      if (initialized.has(dialog)) return;
      initialized.add(dialog);
      const media = window.matchMedia('(max-width: 989px)');
      const sync = () => {
        if (dialog.open) dialog.close();
        if (!media.matches) dialog.show();
      };
      media.addEventListener('change', sync);
      sync();
    });
  }

  function showToast(message) {
    const toast = document.getElementById('CartStatus');
    if (!toast) return;
    toast.querySelector('[data-cart-message]').textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      if (!toast.contains(document.activeElement) && !toast.matches(':hover')) toast.hidden = true;
    }, 8000);
  }

  function closeMenu() {
    const dialog = document.querySelector('[data-mobile-menu]');
    if (dialog?.open) dialog.close();
    const trigger = document.querySelector('[data-open-menu]');
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.focus();
  }

  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-menu]');
    if (opener) {
      const menu = document.querySelector('[data-mobile-menu]');
      menu?.showModal();
      opener.setAttribute('aria-expanded', 'true');
    }
    if (event.target.closest('[data-close-menu]')) closeMenu();
    const filterOpener = event.target.closest('[data-open-filters]');
    if (filterOpener) document.getElementById(filterOpener.getAttribute('aria-controls'))?.showModal();
    if (event.target.closest('[data-close-filters]')) event.target.closest('dialog')?.close();
    if (event.target.tagName === 'DIALOG' && event.target.matches(':modal')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
    if (event.target.closest('[data-close-toast]')) document.getElementById('CartStatus').hidden = true;
    const thumbnail = event.target.closest('[data-gallery-thumb]');
    if (thumbnail) {
      const gallery = thumbnail.closest('.product-gallery');
      const main = gallery.querySelector('.product-gallery__main');
      const image = main?.querySelector('img');
      if (image) {
        image.removeAttribute('srcset');
        image.src = thumbnail.dataset.src;
        image.alt = thumbnail.dataset.alt;
        main.href = thumbnail.dataset.full;
        gallery.querySelectorAll('.gallery-thumb').forEach(button => button.classList.toggle('is-active', button === thumbnail));
      }
    }
  });

  document.addEventListener('close', event => {
    if (event.target.matches('[data-mobile-menu]')) document.querySelector('[data-open-menu]')?.setAttribute('aria-expanded', 'false');
  }, true);

  document.addEventListener('change', async event => {
    if (event.target.matches('[data-sort-select]')) event.target.form?.requestSubmit();
    if (!event.target.matches('[data-option-select]')) return;
    const section = event.target.closest('[data-product-section]');
    if (!section) return;
    const optionName = event.target.dataset.optionName;
    const quantity = section.querySelector('[name="quantity"]')?.value || '1';
    const optionValues = [...section.querySelectorAll('[data-option-select]')].map(select => select.value).join(',');
    variantController?.abort();
    variantController = new AbortController();
    const url = new URL(section.dataset.productUrl, window.location.origin);
    url.searchParams.set('section_id', section.dataset.productSection);
    url.searchParams.set('option_values', optionValues);
    const submit = section.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    section.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, { signal: variantController.signal });
      if (!response.ok) throw new Error(strings.variant_error);
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updated = parsed.querySelector('[data-product-section]');
      if (!updated) throw new Error(strings.variant_error);
      const quantityInput = updated.querySelector('[name="quantity"]');
      if (quantityInput) quantityInput.value = quantity;
      section.replaceWith(updated);
      updated.querySelector(`[data-option-name="${CSS.escape(optionName)}"]`)?.focus({ preventScroll: true });
      const variantId = updated.querySelector('[name="id"]')?.value;
      if (variantId) {
        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set('variant', variantId);
        pageUrl.searchParams.delete('option_values');
        history.replaceState({}, '', pageUrl);
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        const message = section.querySelector('.product-form-message');
        if (message) message.textContent = strings.variant_error;
        section.removeAttribute('aria-busy');
      }
    }
  });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-quick-add]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    const submit = form.querySelector('button[type="submit"]');
    if (!submit || submit.disabled) return;
    const message = form.querySelector('.product-form-message');
    if (message) message.textContent = '';
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || strings.add_error);
      if (message) message.textContent = strings.added;
      showToast(strings.added);
      try {
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-cart-count]').forEach(count => {
            count.textContent = cart.item_count;
            count.hidden = cart.item_count === 0;
          });
        }
      } catch {}
    } catch (error) {
      if (message) message.textContent = error.message || strings.add_error;
      else showToast(error.message || strings.add_error);
    } finally {
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
    }
  });

  window.addEventListener('scroll', updateHeader, { passive: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const accordion = event.target.closest('details');
    if (accordion) accordion.open = true;
  });
  init();
})();
